/**
 * @generated SignedSource<<e465694549ae3af21f864e8c74a0262b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_item$data = {
  readonly attributes: {
    readonly leadTime: ReadonlyArray<{
      readonly option: {
        readonly urlLabel: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_item" | "PdpSharedShippingInfoWrapper_item" | "PdpSharedShipsFrom_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_item";
};
export type PdpRespSidebarBlurbShipping_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingHolidayDelivery_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShipsFrom_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "leadTime",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AttributeOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b2694da2a70ab0937a535e0fd884d694";

export default node;
